/* Copyright (c) 2020-2024, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Breakpoints } from '@angular/cdk/layout';
import { Provider } from '@angular/core';
import { BREAKPOINT, BreakPoint } from '@angular/flex-layout';

// iPhone/iPad dimensions are listed in https://developer.apple.com/design/human-interface-guidelines/ios/visual-design/adaptivity-and-layout/
const MAX_IPHONE_WIDTH = '430px';
const MAX_IPHONE_HEIGHT = '932px';
const MAX_IPAD_WIDTH = '1024px';
const MAX_IPAD_HEIGHT = '1366px';

const PORTRAIT = '(orientation: portrait)';
const LANDSCAPE = '(orientation: landscape)';
const IPHONE_PORTRAIT = `(max-width: ${MAX_IPHONE_WIDTH}) and (max-height: ${MAX_IPHONE_HEIGHT}) and ${PORTRAIT}`;
const IPHONE_LANDSCAPE = `(max-width: ${MAX_IPHONE_HEIGHT}) and (max-height: ${MAX_IPHONE_WIDTH}) and ${LANDSCAPE}`;

const IPHONE_SE_LANDSCAPE = `(max-width: 568px) and (max-height: 320px) and ${LANDSCAPE}`;
const IPHONE_8_PORTRAIT = `(max-width: 375px) and (max-height: 667px) and ${PORTRAIT}`;

export const MobileBreakpoints = {
    IPhone: `${IPHONE_PORTRAIT}, ${IPHONE_LANDSCAPE}`,
    IPhoneLandscape: `${IPHONE_LANDSCAPE}`,
    IPhonePortrait: `${IPHONE_PORTRAIT}`,
    IPhoneSELandscape: `${IPHONE_SE_LANDSCAPE}`,
    IPhone8Portrait: `${IPHONE_8_PORTRAIT}`,
    IPad: `(max-width: ${MAX_IPAD_WIDTH}) and (max-height: ${MAX_IPAD_HEIGHT}) and ${PORTRAIT},
             (max-width: ${MAX_IPAD_HEIGHT}) and (max-height: ${MAX_IPAD_WIDTH}) and ${LANDSCAPE}`
};

const MOBILE_BREAKPOINTS: BreakPoint[] = [
    {
        alias: 'lt-400',
        overlapping: true,
        mediaQuery: 'screen and (max-width: 399.98px)',
        priority: 1050 // higher than lt-sm
    },
    {
        alias: 'lt-360',
        overlapping: true,
        mediaQuery: 'screen and (max-width: 359.98px)',
        priority: 1150
    },
    {
        alias: 'lt-340',
        overlapping: true,
        mediaQuery: 'screen and (max-width: 339.98px)',
        priority: 1250
    },
    {
        alias: 'iphone',
        mediaQuery: MobileBreakpoints.IPhone
    },
    {
        alias: 'ipad',
        mediaQuery: MobileBreakpoints.IPad
    },
    {
        alias: 'handset',
        mediaQuery: Breakpoints.Handset
    }
];

export const MobileBreakPointsProvider: Provider[] = [
    {
        provide: BREAKPOINT,
        useValue: MOBILE_BREAKPOINTS,
        multi: true
    }
];
